﻿import * as pkijs from 'pkijs';

declare module 'pkijs' {
    interface CertificationRequest {
        /** 
         * Added at runtime via prototype 
         * @param foo  some argument
         */
        toPem(): string
    }
}

declare global {
    interface CryptoKey {
        /** 
         * Added at runtime via prototype 
         * @param foo  some argument
         */
        toPem(): Promise<string>
    }
}

pkijs.CertificationRequest.prototype.toPem = function () {
    return `-----BEGIN CERTIFICATE REQUEST-----
${this.toString("base64")}
-----END CERTIFICATE REQUEST-----`
}


CryptoKey.prototype.toPem = async function (): Promise<string> {
    var key = this as CryptoKey;
    if (key.type == "public") {
        return await exportPublicKeyToPem(key);
    }
    else if (key.type == "private") {
        return await exportPrivateKeyToPem(key);
    }
    else {
        throw new Error("Can't convert this key to PEM");
    }
}


export async function exportPublicKeyToPem(key: CryptoKey): Promise<string> {
    // 1. Export the key to SPKI (SubjectPublicKeyInfo) DER format
    const spki = await crypto.subtle.exportKey('spki', key);

    // 2. Convert ArrayBuffer to a base64 string
    const b64 = btoa(String.fromCharCode(...new Uint8Array(spki)));

    // 3. Split into 64‑char lines
    const lines = b64.match(/.{1,64}/g) || [];

    // 4. Wrap with PEM header/footer
    return [
        '-----BEGIN PUBLIC KEY-----',
        ...lines,
        '-----END PUBLIC KEY-----'
    ].join('\n') + '\n';
}

export async function exportPrivateKeyToPem(key: CryptoKey): Promise<string> {
    // 1. Export the key to SPKI (SubjectPublicKeyInfo) DER format
    const spki = await crypto.subtle.exportKey('pkcs8', key);

    // 2. Convert ArrayBuffer to a base64 string
    const b64 = btoa(String.fromCharCode(...new Uint8Array(spki)));

    // 3. Split into 64‑char lines
    const lines = b64.match(/.{1,64}/g) || [];

    // 4. Wrap with PEM header/footer
    return [
        '-----BEGIN PRIVATE KEY-----',
        ...lines,
        '-----END PRIVATE KEY-----'
    ].join('\n') + '\n';
}

